import { RouteType } from "types/RouteType";
import estimatingDashboardRoute from "./Dashboard/EstimatingDashboard.Route";
import manholeRoute from "./Manhole/Manhole.Route";
import jobListRoute from "./JobManagement/JobList.Route";
import jobDetailRoute from "./JobManagement/JobDetail.Route";

const estimatingRoutesList: RouteType[] = [
  estimatingDashboardRoute,
  manholeRoute,
  jobListRoute,
  jobDetailRoute,
];

export default estimatingRoutesList;
